<app-banner-app [retroSelected]=false></app-banner-app>

<br>
<div style="background-color: #DFEAFF;">
    <br>
    <div class="container">
        <br><br><br><br><br><br>
        <div class="row contenido">
            <div class="col">
                <div class="textoArriba">
                    <div>
                        <h3 class="texto2">Cotización en pausa</h3>
                        <h5 class="texto1">Has estado inactivo por un tiempo. <br>
                            Si necesitas ayuda, no dudes en contactarnos.
                        </h5>
                    </div>
                    <br>
                    <img src="./assets/img/CotizacionPausa.png" />
                    <br><br><br>

                    <div class="container tamanioBoton">
                        <div class="row">
                            <div class="col">
                                <button class="btn btn-primary w-100 py-2 botonAsesor" type="submit"
                                    (click)="contactarAsesor();cotizacionEnPausa()">
                                    Contactar asesor
                                </button>
                            </div>
                            <br><br><br>
                            <div class="col">
                                <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit"
                                    onclick="javascript: history.go(-1)">
                                    Seguir en línea
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="textoAbajo">
                    <img src="./assets/img/CotizacionPausa.png" />
                    <br><br>
                    <div>
                        <h3 class="texto2">Cotización en pausa</h3>
                        <h5 class="texto1">Has estado inactivo por un tiempo. <br>
                            Si necesitas ayuda, no dudes en contactarnos.
                        </h5>
                    </div>
                    <br><br><br>
                    <div class="container tamanioBoton">
                        <div class="row">
                            <div class="col">
                                <button class="btn btn-primary w-100 py-2 botonAsesor" type="submit"
                                    (click)="contactarAsesor()">
                                    Contactar asesor
                                </button>
                            </div>
                            <br><br><br>
                            <div class="col">
                                <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit"
                                    onclick="javascript: history.go(-1)">
                                    Seguir en línea
                                </button>
                                <!-- <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit"
                                    (click)="regresarPagina()">
                                    Seguir en línea
                                </button> -->
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <br><br><br><br>
    <app-footer-app />

</div>